<template>
    <div>
        <div class="no-result-container" v-if="showNoData">
            <h2>No data available for Tax</h2>
        </div>
        <div v-else>
            <div class="container">
                <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
                <showDetails v-if="taxData" :data="taxData" :highlight-keys="['additional_information']" />
            </div>
            <div class="card" v-if="tableData.length">
                <div class="card-header">
                    <h2>Documents</h2>
                </div>
                <v-data-table
                    :headers="headers"
                    :items="tableData"
                    item-key="id"
                    :server-items-length="tableData.length"
                    :loading="loading"
                    loading-text="Loading... Please wait"
                    fixed-header
                    :hide-default-footer="true"
                    :hide-default-header="true"
                    class="custom-v-table"
                >
                    <template #header="{ props }">
                        <tr class="custom-header-row">
                            <th v-for="header in props.headers" :key="header.value">{{ header.text }}</th>
                        </tr>
                    </template>
                    <template #item="{ item }">
                        <tr class="custom-data-row">
                            <td>{{ item.content_location}}</td>
                            <td>{{ item.site_type }}</td>
                            <td>
                                <div class="action-column">
                                    <v-btn
                                        color="primary"
                                        class="navigation-btn"
                                        v-if="item.json_data.Site_url"
                                        @click="handleAction({file_path:item.json_data.Site_url},'open-site')"
                                        >Link to website</v-btn
                                    >
                                    <v-btn color="primary" class="navigation-btn" @click="handleAction(item)"
                                        >View file</v-btn
                                    >
                                    <v-btn color="primary" class="navigation-btn" @click="handleAction(item,'download')"
                                        >Download file</v-btn
                                    >
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
            <additionalRunSheetTable v-if="additionalTables.length > 0" :tables="additionalTables" />
            <filePreviewModal :dialog="dialog" :data="selectedData" @close="dialog = false" />
        </div>
    </div>
</template>

<script>
import { GETSCRAPPEDRUNSHEETDATA } from '@/store/actions.type'
import filePreviewModal from '@/components/filePreviewModal.vue'
import additionalRunSheetTable from './commonComponents/additionalRunSheetTable.vue'
import showDetails from './commonComponents/showDetails.vue'
import { IMPORTANT_ORDER_DETAILS_KEYS, SITE_TYPE } from '@/constants'

export default {
  name: 'RunSheetTaxTab',
  components: {
    filePreviewModal,
    additionalRunSheetTable,
    showDetails
  },
  data () {
    return {
      scrappedData: [],
      taxData: null,
      tableData: [],
      headers: [
        { text: 'Location', value: 'content_location', sortable: false },
        { text: 'Site Type', value: 'site_type', sortable: false },
        { text: 'Action', value: 'action', sortable: false }
      ],
      options: {},
      loading: false,
      dialog: false,
      selectedData: null,
      showNoData: false,
      importantOrderDetails: IMPORTANT_ORDER_DETAILS_KEYS,
      additionalTables: []
    }
  },
  props: {
    order: null,
    fetchOnActive: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      this.$store.dispatch(GETSCRAPPEDRUNSHEETDATA, {
        orderId: this.order.id,
        siteType: SITE_TYPE.TAX
      }).then(response => {
        this.scrappedData = response.results
        this.filterAndSetData()
      }).finally(() => {
        this.loading = false
      })
    },
    filterAndSetData () {
      if (this.scrappedData && this.scrappedData.length) {
        const data = this.scrappedData.find(item => item.data_type === 'json')
        if (data && data.json_data) {
          const updatedData = data.json_data
          this.taxData = updatedData
          if (updatedData) {
            const additionalTables = updatedData.additional_tables
            this.additionalTables = additionalTables || []
          }
        }
        const tableData = this.scrappedData.filter(item => item.data_type !== 'json')
        this.tableData = tableData || []
      }
    },
    handleAction (item, mode = 'view') {
      if (item.data_type === 'pdf' && mode === 'view') {
        this.selectedData = item
        this.dialog = true
      } else {
        const { file_path: fileLink } = item
        window.open(fileLink, '_blank')
      }
    },
    updateNoDataState () {
      const hasScrappedData = this.scrappedData && this.scrappedData.length > 0
      const hasTableData = this.tableData && this.tableData.length > 0
      const hasTaxData = this.taxData !== null
      const hasAdditionalTables = this.additionalTables && this.additionalTables.length > 0

      this.showNoData = !this.loading && !hasScrappedData && !hasTableData && !hasTaxData && !hasAdditionalTables
    }
  },
  watch: {
    fetchOnActive (newVal) {
      if (newVal) {
        this.getData()
      }
    },
    scrappedData: 'updateNoDataState',
    tableData: 'updateNoDataState',
    taxData: 'updateNoDataState',
    additionalTables: 'updateNoDataState',
    loading: 'updateNoDataState'

  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  margin: 0 !important;
  padding: 12px 0 !important;
  max-width: 100% !important;
}

.details-container {
  width: 100%;
  height: 100%;
  padding: 12px;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.capitalise {
  text-transform: capitalize;
}
.tax-details-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.text-content {
  font-size: 14px;
}

.navigation-btn {
  width: fit-content;
  height: 28px !important;
  border-radius: 4px;
  padding: 4px;
  font-size: 12px;
}

.table-container {
  padding-top:0;
  margin-bottom: 12px;
  border-radius: 0;
}

.important-order-details {
  width: 100%;
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.important-order-details span {
  font-size: 16px;
  text-transform: capitalize;
}

.action-column {
  display: flex;
  gap:12px;
}

.custom-v-table {
  margin-bottom: 12px;
  border-radius: 0;
}

.card {
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 12px;
  margin-bottom: 12px;
}

.card-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.custom-v-table >>> table {
  width: 100%;
  margin-top: 12px;
  border-collapse: separate !important;
  border-spacing: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.custom-v-table .custom-header-row {
  background-color: #f9fafb;
}

.custom-v-table >>> th {
  text-align: left;
  padding: 8px 12px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
}

.custom-v-table tbody tr {
  font-size: 16px;
  transition: background-color 0.2s ease;
}

.custom-v-table tbody tr:hover {
  background-color: #f9fafb;
}

.custom-v-table .custom-data-row td {
  padding: 8px 12px;
  font-size: 14px !important;
  border-bottom: 1px solid #e5e7eb;
}

.custom-v-table tbody tr:last-child td {
  border-bottom: none;
}

.no-result-container{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
font-size: 10px;
    font-weight: 600;
    background-color: white;
    margin-top: 12px;
}
</style>
